import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { Ispezione } from 'src/app/model/ispezioni/Ispezione';
import { IspezioniService } from 'src/app/services/ispezioni/ispezioni.service';
import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';
import { patchCss } from 'src/app/shared/functions/ovverideCss';

registerLocaleData(localeIt, 'it-IT');

@Component({
  selector: 'app-dashboard-collaudi',
  templateUrl: './dashboard-collaudi.component.html',
  styleUrls: ['./dashboard-collaudi.component.scss'],
})
export class DashboardCollaudiComponent implements OnInit, OnDestroy {
  private langChangeSub!: Subscription;
  private ispezioniCache: Ispezione[] = [];
  collaudiDownloadComplete = false;
  collaudiPresenti = false;
  erroreGestitoMex: String = null;
  serverError: boolean = false;
  _isTeamView: boolean = false;
  private datePipe = new DatePipe('it-IT');

  tableConfig;

  emptyImage: string =
    sessionStorage.getItem('theme') === 'dark'
      ? '../../../assets/images/empty-state-dark.svg'
      : '../../../assets/images/empty-state-light.svg';

  private readonly tableHeaderKeys = [
    {
      text: 'ispezioni.inspectionDate',
      columnId: 'dataIspezione',
      width: '35%',
    },
    { text: 'ordini.supplier', columnId: 'fornitore', width: '35%' },
    { text: 'ispezioni.type', columnId: 'tipoIspezione', width: '30%' },
  ];

  @Input() set isTeamView(value: boolean) {
    if (!CommonUtils.isNotNullOrUndefined(this._isTeamView)) {
      this._isTeamView = value;
    } else if (value !== this._isTeamView) {
      this._isTeamView = value;
      this.caricaIspezioni();
    }
  }

  constructor(
    private ispServ: IspezioniService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.caricaIspezioni();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      if (this.ispezioniCache.length > 0) {
        this.buildTableConfig();
      }
    });
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }

  private buildTableConfig(): void {
    const keys = this.tableHeaderKeys.map(h => h.text);
    const translations = this.translate.instant(keys);

    this.tableConfig = {
      tableWidthPercentage: true,
      hasInfoHeader: false,
      tableAriaLabel: this.translate.instant('Dashboard.IspezioniTabStr'),
      tableHeader: {
        tableCellsHeader: this.tableHeaderKeys.map(h => ({
          text: translations[h.text] || h.text,
          columnId: h.columnId,
          columnWidth: h.width,
          textAlign: 'left',
        })),
        hiddenHeader: false,
        secondRightIconSticky: true,
      },
      tableRows: this.ispezioniCache.map(isp =>
        this.mapIspezioneToTableRow(isp)
      ),
    };
  }

  caricaIspezioni() {
    this.collaudiDownloadComplete = false;
    this.collaudiPresenti = false;
    this.erroreGestitoMex = null;
    this.serverError = false;
    this.ispServ
      .getIspezioniService(
        this._isTeamView,
        AppConstants.DASHBOARD_FIRST,
        AppConstants.DASHBOARD_ORDINI_LENGHT,
        true
      )
      .subscribe(
        res => {
          if (res['errorMex'] != null) {
            this.erroreGestitoMex = res['errorMex'];
            console.log('Get Non Conformità error: ' + res['errorMex']);
          } else {
            let ispezioni = res['respObj'] || [];
            if (ispezioni.length > 0) {
              this.ispezioniCache = ispezioni;
              this.buildTableConfig();
              this.collaudiPresenti = true;
            } else {
              this.ispezioniCache = [];
              this.collaudiPresenti = false;
            }
          }
          this.collaudiDownloadComplete = true;
        },
        err => {
          this.serverError = true;
          console.error('Error catch', err);
          this.collaudiDownloadComplete = true;
        }
      );
  }

  private mapIspezioneToTableRow(element: Ispezione): any {
    let dateText: string;
    if (element.nuovaDataPropostaInizio != null) {
      dateText = `${this.datePipe.transform(element.nuovaDataPropostaInizio, 'dd.MM.yyyy - ') || '-'} ${this.datePipe.transform(element.nuovaDataPropostaFine, 'dd.MM.yyyy') || '-'}`;
    } else {
      dateText = `${this.datePipe.transform(element.dataInizio, 'dd.MM.yyyy - ') || '-'} ${this.datePipe.transform(element.dataFine, 'dd.MM.yyyy') || '-'}`;
    }

    return {
      tableCells: [
        { type: 'text', text: dateText },
        { type: 'text', text: element.fornitore?.ragioneSociale || '-' },
        {
          type: 'text',
          text: element.tipoIspezione
            ? this.translate.instant(element.tipoIspezione)
            : '-',
        },
      ],
      secondRightIcon: 'icon-arrow-right',
      secondRightIconAriaLabel: 'Vai al dettaglio ispezione',
    };
  }

  onSecondRightIconClick(event: any) {
    let rowIndex: number;
    if (
      typeof event?.detail?.row === 'string' &&
      event.detail.row.startsWith('row-')
    ) {
      rowIndex = Number.parseInt(event.detail.row.replace('row-', ''), 10);
    } else {
      rowIndex = event?.detail?.row;
    }

    const ispezione = this.ispezioniCache[rowIndex];
    if (ispezione?.id) {
      this.navigate(ispezione.id);
    }
  }

  goToIspezioni() {
    this.router.navigate([AppConstants.ISPEZIONI_ROUTE], {
      state: { currentDate: new Date() },
    });
  }

  navigate(id) {
    this.router.navigate(['/ispezioni/', id]);
  }
}
